import axios from "axios";

const getSearchResultFromUrl = (url, payload) => {
  return new Promise((resolve, reject) => {
    return axios({
      url: url,
      method: "post",
      data: {
        ...payload,
        language: window.currentLanguage,
        country:
          window.currentCountry.toLowerCase() === "gb"
            ? "en"
            : window.currentCountry // TODO: think of better solution/ technical concept for this quick fix,
      }
    })
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export default getSearchResultFromUrl;
